import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { FormControlListIds } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { CustomFieldsEditModels } from './models/custom-fields-edit.models';
import { CustomFieldsAddModels } from './models/custom-fields-add.models';
import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { AccountModuleId, CaseModuleId, OpportunityModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AppMainComponent } from '../../../../app.main.component';
import { ObjectNames } from '../../../../shared/constants';
import { AddYearPipe } from '../../../../shared/pipes/add-year.pipe';
import { Answer, ObjectNames as ChannelObjectNames, Severity, Status } from '../../constants/constants';
import data from '../../staticJSON/customfield.json';
import { CustomService } from '../custom.service';
import { SectionService } from '../section/section.service';
import { ListService } from './list.service';
import { Sections } from 'src/app/accounts-v2/accounts.constant';
import { SharedTemplateService } from 'src/app/modules/shared/services/template.service';
import { alphaNumericValidator } from 'src/app/modules/shared/validators/alpha-numeric.validator';
import { noSeriesStartEndEndValidator } from 'src/app/modules/shared/validators/no-series-start-end.validator';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { Subject, takeUntil } from 'rxjs';
import { PermissionService } from 'src/app/service/permission.service';

@Component({
    selector: 'app-crm-field-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class CrmCustomFieldListComponent implements OnInit, OnChanges, OnDestroy {

    allCustomFields = [];
    @Input() moduleList = [];
    @Input() typesList = [];
    customFieldData = [];
    inventoryObjId: any;
    allModules = [];
    addUpdateModules = [];
    allCustomFieldTypes = [];
    displayAddEditCustomField: boolean = false;
    customFieldNameExist: boolean = false;
    allSections = [];
    sections = [];
    showCustomFieldValidation: boolean = false;
    showOptionValidationError: boolean = false;
    allLevels = [];
    allTypes = [];
    allCategories = [];
    showAllCustomFieldTypes: any = [];
    isCustomFieldAdd: boolean = false;
    isCustomFieldEdit: boolean = false;
    addEditCustomFieldHeader;
    seletedCustomField;
    customFieldForm: FormGroup;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    addNewOptionForm: FormGroup;
    pickListValues = [];
    displayAddNewOption: boolean = false;
    addEditOptionHeader;
    statusConstants = Status;
    answertypeConstants = Answer;
    formControls = FormControlListIds;
    allTemplates = [];
    userPermissions: any[] = [];
    selectedModule;
    crudRemoveModuleName = ChannelObjectNames.leadConstants.leadFieldName;
    fieldId;
    moduleId: number = 2;

    //Barcode Types
    barcodeTypes: { name: string, value: string }[] = [
        { name: 'CODE128', value: 'CODE128'}
    ];

    /** newFields */
    newFields = [
        FormControlListIds.MultiLine,
        FormControlListIds.Email,
        FormControlListIds.Phone,
        FormControlListIds.URL,
        FormControlListIds.IPAddress,
        FormControlListIds.DateTimePicker,
        FormControlListIds.AutoNumber,
        FormControlListIds.Lookup,
        FormControlListIds.UserLookup,
        FormControlListIds.Time,
        FormControlListIds.Formula,
        FormControlListIds.EncryptedText,
        FormControlListIds.RichText,
        FormControlListIds.Barcode,
        FormControlListIds.Currency,
        FormControlListIds.Percentage
    ];

    //Expression Formula
    availableFieldsForExpression: any[] = [];
    displayAddExpression: boolean = false;
    expressionText: string = "";

    /** variable for form array: projected modules */
    isProjectedEnabled = false;
    showProjectSection = false;
    targetModulesOptions = [];
    targetModuleId: any[] = [];
    targetModulesSection:  any[] = [];
    currencies: any[] = [];
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();


    constructor(private listService: ListService, private messageService: MessageService, private confirmationService: ConfirmationService,
        private app: AppMainComponent, private customService: CustomService, private fb: FormBuilder, private yearPipe: AddYearPipe,
        private titlecasePipe: TitleCasePipe, private sectionService: SectionService, private appMainService: AppMainService,
        private sharedTemplateService: SharedTemplateService,
        private importService: ImportserialService,
        private permissionService:PermissionService) { }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.typesList && changes.typesList.currentValue) {
            this.allTypes = changes.typesList.currentValue;
        }
    }

    ngOnInit(): void {
        this.userPermissions = this.permissionService.getPemrissionData();
        this.loadCurrencies();
        this.customService.getCustom().subscribe(custom => {
            if (custom) {
                this.showAddCustomFieldPopUp();
            }
        });
        this.initFieldForm();
        this.getAllCats();
        this.getLevels();
        this.getTypes();
        this.getModules();
    }

    initFieldForm(){
        this.customFieldForm = this.fb.group({
            id: [0],
            createdSource: [this.app.userIP],
            updatedSource: [this.app.userIP],
            createdBy: [this.app.user.userId],
            updatedBy: [this.app.user.userId],
            createdDate: [new Date],
            updatedDate: [new Date().toISOString()],
            organizationId: [this.app.companyId],
            objectId: [''],
            section: ['', [Validators.required]],
            typeId: [''],
            formControlId: ['', [Validators.required]],
            title: [''],
            description: [''],
            fieldName: ['', [Validators.required, alphaNumericValidator()]],
            fieldId: [''],
            dataType: [''],
            type: [null], //Barcode Type
            expression: [''],
            prefix: ['', [Validators.maxLength(3), alphaNumericValidator()]],
            startingSequenceNumber: [null],
            endingSequenceNumber: [null],
            length: [0],
            displayInModule: [''],
            isRequired: [false],
            isAppend: [false],
            isDisplayForWeb: [false],
            isDisplayForMobile: [false],
            isDisplayForQuestionnaire: [false],
            statusId: [Status.ACTIVE],
            isValid: [true],
            validFromDate: [new Date().toISOString()],
            validToDate: [this.yearPipe.transform(new Date())],
            pickListValues: [],
            currencyId: [null],
            maxLengthAfterDecimal: [null, [Validators.min(1), Validators.max(6)]],
            displayLength: [null, [Validators.min(0), Validators.max(10)]],
            isProjected : [false],
            projectedFields: this.fb.array([]),
        },{
            validator: noSeriesStartEndEndValidator
        });

        this.formErrorHandler.handleErrors(this.customFieldForm, this.detailsFormErrors, {
            fieldName: {
                required: 'Enter field name',
                alphaNumeric: 'Only alphabets, numbers, spaces, hyphens, and underscores are allowed.'
            },
            type: {
                required: 'Select any barcode type'
            },
            prefix: {
                required: 'Enter auto number prefix',
                alphaNumeric: 'Only alphabets, numbers, spaces, hyphens, and underscores are allowed.'
            }
        });
    }

    changeModule() {
        this.customFieldForm.controls['objectId'].setValue(this.selectedModule);
        this.getCustomFieldTypes();
        this.getConfigurationTypes();
    }

    getCustomFieldTypes() {
        this.loadCustomFields();
        this.listService.getAllCustomFieldTypes(this.selectedModule.id).then(fldtyps => {
            this.allCustomFieldTypes = fldtyps;
            this.setAvailableFieldTypes();
        });
    }

    getConfigurationTypes(event?) {
        const selectedModuleName = event ? event.value.name : this.selectedModule.name;
        this.moduleId = event ? event.value.id : this.selectedModule.id;
        if (this.moduleId === AccountModuleId || this.moduleId === OpportunityModuleId || this.moduleId === CaseModuleId) {
            this.getAccountTemplates();
            this.getAccountTemplateSections();
        } else {
            let fromValue = this.customFieldForm.value;
            let template = fromValue.objectId.name == ChannelObjectNames.caseConstants.caseFieldName ? ChannelObjectNames.caseConstants.Channel_Template :
                fromValue.objectId.name == ChannelObjectNames.opportunityConstants.opportunityFieldName ? ChannelObjectNames.opportunityConstants.Channel_Template :
                    fromValue.objectId.name == ChannelObjectNames.leadConstants.leadFieldName ? ChannelObjectNames.leadConstants.Channel_Template :
                        ChannelObjectNames.accountConstants.Channel_Template;

            this.appMainService.isShowSpinner('loadingTypes')
            this.sectionService.getAllTypes().subscribe(types => {
                const channelTypeId = types.find(type => type.name == template).id;
                this.loadConfigurations(channelTypeId, selectedModuleName, 'popup',);
                this.appMainService.isHideSpinner('loadingTypes')
            },
                err => {
                    this.appMainService.isHideSpinner('loadingTypes')
                });
        }
    }

    loadConfigurations(typeId, selectedModuleName, forType?) {
        let template = '';
        let fromValue = this.customFieldForm.value;

        if ((forType && forType == 'popup' && fromValue.objectId.name == ChannelObjectNames.caseConstants.caseFieldName) || (!forType && this.selectedModule.name == ChannelObjectNames.caseConstants.caseFieldName)) {
            template = ObjectNames.TEMPLATE_CASES_CONFIGURATION;
        } else if ((forType && forType == 'popup' && fromValue.objectId.name == ChannelObjectNames.opportunityConstants.opportunityFieldName) || (!forType && this.selectedModule.name == ChannelObjectNames.opportunityConstants.opportunityFieldName)) {
            template = ObjectNames.OPPORTUNITY_TEMPLATE;
        } else if ((forType && forType == 'popup' && fromValue.objectId.name == ChannelObjectNames.leadConstants.leadFieldName) || (!forType && this.selectedModule.name == ChannelObjectNames.leadConstants.leadFieldName)) {
            template = ObjectNames.LEAD_TEMPLATE;
        } else {
            template = ObjectNames.ACCOUNT_TEMPLATE;
        }

        this.appMainService.isShowSpinner('loadingConfig')

        this.listService.getConfigurationByModuleName(selectedModuleName).subscribe(configs => {
            const caseTemplatesConfig = configs.find(s => s.name == template && s.typeId == typeId);
            this.allTemplates = JSON.parse(caseTemplatesConfig.configurationDetails[0].configJSONValue);
            this.appMainService.isHideSpinner('loadingConfig')
        }, err => {
            this.appMainService.isHideSpinner('loadingConfig')
        });
    }

    loadTypewiseSections(data) {
        const typeId = data ? data.id : 0;
        const selectedtemplate = this.allTemplates.find(ob => ob.id == typeId);
        this.sections = selectedtemplate ? selectedtemplate.sections.filter(obj => obj.isDisplay === true) : [];
    }

    showAddCustomFieldPopUp() {
        this.pickListValues = [];
        this.sections = [];
        this.allTemplates = [];
        this.showCustomFieldValidation = false;
        this.initFieldForm();
        this.changeModule();
        this.displayAddEditCustomField = true;
        this.isCustomFieldAdd = true;
        this.addEditCustomFieldHeader = ChannelObjectNames.customConstants.AddCustomTitle;
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    getLevels() {
        this.listService.getAllLevels().then(levels => {
            this.allLevels = levels;
        });
    }

    getTypes() {
        this.listService.getAllTypes().then(types => {
            this.allTypes = types;
        });
    }

    getAllCats() {
        this.listService.getAllCategories().then(cates => {
            this.allCategories = cates;
        });
    }

    getModules() {
        this.allModules = this.app.preLoadedObjects.filter(obj => (obj.name == ChannelObjectNames.caseConstants.caseFieldName ||
            obj.name == ChannelObjectNames.caseConstants.AccountFieldName ||
            obj.name == ChannelObjectNames.opportunityConstants.opportunityFieldName));
            const permittedModuleIds = this.userPermissions
            .filter(p =>
              p.permissions.some(permission => permission.statusId === 1)
            )
            .map(p => p.objectName);
          const filteredListNosModules = this.allModules.filter(module =>
            permittedModuleIds.includes(module.name)
          );      
          this.allModules= filteredListNosModules;
        this.addUpdateModules = this.allModules.filter(obj => obj.name != ChannelObjectNames.leadConstants.leadFieldName);
        this.targetModulesOptions = this.allModules.filter(obj => obj.name === ChannelObjectNames.opportunityConstants.opportunityFieldName);
        this.selectedModule = this.allModules[0];
        this.getCustomFieldTypes();
        this.getConfigurationTypes();
    }

    loadCustomFields() {
        this.listService.getAllCustomFields(this.selectedModule.id).then(fields => {
            this.customFieldData = [];
            this.allCustomFields = [];
            if (fields && fields.length > 0) {
                for (let l of fields) {
                    const customFieldModule = this.allModules.find(el => el.id == l.objectId)
                    let eachRecord = {
                        id: Number(l.id + ""),
                        name: l.name,
                        module: customFieldModule?.name,
                        moduleId: customFieldModule.id,
                        formControl: l.formControl,
                        isRequired: l.isRequired,
                        isAppend: l.isAppend,
                        statusId: l.statusId,
                        statusName: l.status?.name,
                        section: l.section,
                        configurationId: l.configurationId,
                        isEdit: l.isEdit,
                        isDelete: l.isDelete,
                        isMapped: l.isMapped
                    }
                    this.customFieldData.push(eachRecord);
                }
            }
            this.allCustomFields = this.customFieldData;
        });
    }

    loadExpressionAvailableFields(openAddExpression: boolean = true) {
        this.listService.getAllCustomFields(this.selectedModule.id).then(fields => {
            this.availableFieldsForExpression = (fields||[]).filter(field=> field.statusId==1 && [FormControlListIds.Number,FormControlListIds.Decimal,FormControlListIds.Currency,FormControlListIds.Percentage].includes(field.formControlId));
            this.availableFieldsForExpression.map(field=>{
                field['labelname'] = field.name;
                field['field'] = field.name;
            });

            if(openAddExpression){
                this.openExpressionAdd();
            }
        });
    }

    async showEditCustomFieldPopUp(field) {
        this.moduleId = this.selectedModule.id;
        this.pickListValues = [];
        this.showCustomFieldValidation = false;
        this.seletedCustomField = field;
        this.clearProjectedFields(); //Clear Project Section
        const resp = await this.listService.getCustomFieldById(field.id, this.selectedModule.id);
        this.fieldId = resp?.formControlId;
        let customFieldValue = resp;
        this.seletedCustomField = customFieldValue;
        const pickupList = JSON.parse(customFieldValue.pickListValues);
        customFieldValue.pickListValues = pickupList;

        this.customFieldForm.patchValue(customFieldValue);
        if(!this.newFields.includes(this.fieldId)){
            this.showProjectSection = true;
        }
        else{
            this.showProjectSection = false;
        }
        if(customFieldValue.isProjected){
            this.isProjectedEnabled = true;
            this.patchProjectedFields(customFieldValue)
        }
        this.customFieldForm.controls['objectId'].setValue(this.allModules.find(el => el.id == customFieldValue.objectId));
        const formControlIdVal = this.allCustomFieldTypes.find(el => el.id == customFieldValue.formControlId)
        this.customFieldForm.controls['formControlId'].setValue(formControlIdVal);
        const filteredType = this.allTemplates.find(type => type.id == field.section.templateId)
        this.customFieldForm.controls['typeId'].setValue(filteredType);
        this.moduleId === 2 || this.moduleId === 3 || this.moduleId === 8 ? this.getAccountTemplateSections(field.section.id) : this.loadTypewiseSections(filteredType);

        const filteredSection = this.sections.find(section => section.id == field.section.id);
        this.customFieldForm.controls['section'].setValue(filteredSection);
        
        const isCurrencyExist = this.currencies.some(currency => currency.id === customFieldValue.currencyId);
        this.customFieldForm.controls['currencyId'].setValue(isCurrencyExist ? customFieldValue.currencyId : null);

        if (customFieldValue.pickListValues !== null && customFieldValue.pickListValues !== undefined) {
            if (customFieldValue.pickListValues.length > 0) {
                this.pickListValues = customFieldValue.pickListValues;
            }
        }
        this.updateRequiredFields();
        this.addEditCustomFieldHeader = ChannelObjectNames.customConstants.EditCustomTitle;
        this.isCustomFieldEdit = true;
        this.isCustomFieldAdd = false;
        this.displayAddEditCustomField = true;

        const fieldNameControl = this.customFieldForm.controls['fieldName'];
        if (fieldNameControl) {
            fieldNameControl.setValidators([Validators.required]);
            fieldNameControl.updateValueAndValidity();
        }
        this.applyValidations();
    }

    patchProjectedFields(responseData: any) {
        const projectedFieldsFormArray = this.customFieldForm.get('projectedFields') as FormArray;
        projectedFieldsFormArray.clear();
        responseData.projectedFields.forEach((field, index) => {
            const projectedFieldGroup = this.fb.group({
                targetModuleId: [field?.targetModuleId || null],
                targetSectionId: [field?.targetSectionId || null],
                targetCustomAttributeId:[field?.targetCustomAttributeId || 0],
                statusId:[1]

            });
            this.targetModuleId[index] = field?.targetModuleId;
            this.getTargetTemplateSections(index);
            projectedFieldsFormArray.push(projectedFieldGroup);
        });
    }

    deleteCustomField(field) {
        if (field.isMapped) {
            this.messageService.add({
                severity: 'error',
                summary: 'Delete',
                detail: 'This custom field cannot be deleted because it is projected from another module.'
            });
            return;
        }
        this.confirmationService.confirm({
            message: 'Do you want to delete this custom field?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            key: 'delete-custom-field',
            accept: () => {
                if (this.selectedModule.id == AccountModuleId || this.selectedModule?.id == OpportunityModuleId || this.selectedModule?.id == CaseModuleId) {
                    this.listService.deleteCustomField(this.selectedModule.id, field.id).subscribe({
                        next: (response) => {
                            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted successfully...' });
                            this.loadCustomFields();
                        },
                        error: (error) => {
                            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: error.error.Message });
                        }
                    });
                } else {
                    this.listService.deletCustomField(field.id, this.selectedModule.id).then(() => {
                        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted successfully...' });
                        this.loadCustomFields();
                    }).catch((err) => {
                        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: err.error.Message });
                    });
                }

            },
            reject: () => {
            }
        });
    }

    addOptionList() {
        this.pickListValues.push({ name: '' });
    }

    deleteCustomOption(index) {
        this.pickListValues.splice(index, 1);
    }

    resetPickList(event) {
        this.fieldId = event.value.id;
        if(!this.newFields.includes(this.fieldId)){
            this.clearProjectedFields();
            this.showProjectSection = true;
        }
        else{
            this.clearProjectedFields();
            this.showProjectSection = false;
        }
        this.applyValidations(this.fieldId);
        this.pickListValues = [];
        const maxLengthAfterDecimal = (event.value.id == this.formControls.Decimal) ? event.value.maxLengthAfterDecimal || 2 : null;
        this.customFieldForm.patchValue({
            maxLengthAfterDecimal: maxLengthAfterDecimal
        })
    }

    checkCustomFieldValidation(value) {
        this.customFieldNameExist = false;
        this.showOptionValidationError = false;

        // Check if field name exists and is a duplicate
        const isDuplicateName = this.isCustomFieldAdd && this.allCustomFields.some(el =>
            el.name?.trim() === value.fieldName?.trim() && el.moduleId === value.objectId?.id
        );

        if (isDuplicateName) {
            this.customFieldNameExist = true;
            return true;
        }

        // Check for general mandatory fields
        if (!value.fieldName || !value.objectId || !value.formControlId || !value.section) {
            return true;
        }

        // Specific form control validations
        if (!this.isValidFormControl(value)) {
            this.showOptionValidationError = true;
            return true;
        }

        return false;
    }

    // Helper function to validate form control-specific rules
    isValidFormControl(value) {
        const isEmptyPickList = this.pickListValues?.length === 0;
        const isEmptyOptionNames = this.pickListValues?.length > 0 ? this.pickListValues.some(option => !option?.name) : false;

        switch (value.formControlId.id) {
            case FormControlListIds.MultipleDropDownList:
            case FormControlListIds.DropDownList:
            case FormControlListIds.CheckBox:
                return !isEmptyPickList && !isEmptyOptionNames;
            case FormControlListIds.RadioButton:
                return this.pickListValues.length >= 2 && !isEmptyOptionNames;
            case FormControlListIds.Decimal:
                return !!value.maxLengthAfterDecimal;
            case FormControlListIds.Barcode:
                return value?.type;
            default:
                return true;
        }
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    saveCustomFieldData() {
        let value = ParseHelper.DeepCopy(this.customFieldForm.getRawValue());
        if (this.checkCustomFieldValidation(value) || this.customFieldForm.invalid) {
            this.showCustomFieldValidation = true;
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
        } else {

            const module = value.objectId;
            this.customFieldNameExist = false;
            this.showOptionValidationError = false;
            this.showCustomFieldValidation = false;
            value.fieldName = value.fieldName?.trim();
            value.description = value?.description?.trim();
            value.objectId = value.objectId.id;
            value.formControl = value.formControlId;
            value.formControlId = value.formControlId.id;
            value.section = {
                id: value.section.id,
                name: value.section.name,
                templateId: value?.typeId?.id || 0,
                templateName: value?.typeId?.templateName || ""
            }
            value.pickListValues = JSON.stringify(this.pickListValues);
            if (value?.objectId == AccountModuleId || value?.objectId == OpportunityModuleId || value?.objectId == CaseModuleId) {

                if (this.isCustomFieldAdd) {
                    this.addAccountCustomField(value);
                } else {
                    this.updateAccountCustomField(value);
                }

            } else {
                this.appMainService.isShowSpinner('SavingCustomField');
                delete value['typeId'];
                let customFieldName = (module.name == ChannelObjectNames.caseConstants.caseFieldName) ? ChannelObjectNames.caseConstants.caseCustomFieldName :
                    (module.name == ChannelObjectNames.opportunityConstants.opportunityFieldName) ? ChannelObjectNames.opportunityConstants.opportunityCustomFieldName :
                        ChannelObjectNames.accountConstants.accountCustomFieldName;

                const customFieldConfigTemp = data;
                customFieldConfigTemp.createdSource = this.app.user.userIP,
                customFieldConfigTemp.updatedSource = this.app.user.userIP,
                customFieldConfigTemp.createdBy = this.app.user.userId,
                customFieldConfigTemp.updatedBy = this.app.user.userId,
                customFieldConfigTemp.createdDate = new Date().toISOString(),
                customFieldConfigTemp.updatedDate = new Date().toISOString(),
                customFieldConfigTemp.organizationId = this.app.user.organizationId,
                customFieldConfigTemp.configJSONValue = JSON.stringify(value),
                customFieldConfigTemp.name = module.name;
                customFieldConfigTemp.objectId = value.objectId,
                customFieldConfigTemp.levelId = this.allLevels.find(el => el.name == ChannelObjectNames.caseConstants.levelName)?.id,
                customFieldConfigTemp.levelRecordId = this.app.user.organizationId,
                customFieldConfigTemp.categoryId = this.allCategories.find(el => el.name == customFieldName)?.id;
                customFieldConfigTemp.statusId = Status.ACTIVE,
                customFieldConfigTemp.typeId = this.allTypes.find(el => el.name == ChannelObjectNames.caseConstants.customFieldName)?.id;
                customFieldConfigTemp.maxLengthAfterDecimal = value.maxLengthAfterDecimal;

                if (this.isCustomFieldAdd) {
                    this.listService.addCustomFieldsConfiguration(customFieldConfigTemp).then(() => {
                        this.appMainService.isHideSpinner('SavingCustomField');
                        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Custom Field added successfully...' });
                        this.displayAddEditCustomField = false;
                        this.fieldId = null;
                        this.getCustomFieldTypes();
                        if (value.objectId != this.selectedModule.id) {
                            this.reloadCustomFields(value)
                        }
                    }, err => {
                        this.fieldId = null;
                        this.appMainService.isHideSpinner('SavingCustomField');
                    });
                } else {
                    customFieldConfigTemp.id = this.seletedCustomField.id;
                    this.listService.updateCustomFieldsConfiguration(customFieldConfigTemp).then(() => {
                        this.appMainService.isHideSpinner('SavingCustomField');
                        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Custom Field updated successfully...' });
                        this.displayAddEditCustomField = false;
                        this.fieldId = null;
                        this.getCustomFieldTypes();
                        if (value.objectId != this.selectedModule.id) {
                            this.reloadCustomFields(value)
                        }
                    }, err => {
                        this.fieldId = null;
                        this.appMainService.isHideSpinner('SavingCustomField');
                    });
                }
            }

        }

    }

    addAccountCustomField(formValue: any) {
        const fieldInfo: CustomFieldsAddModels = {
            fieldName: formValue.fieldName,
            description: formValue?.description?.trim(),
            formControlId: formValue.formControlId,
            moduleId: formValue.objectId,
            isRequired: formValue.isRequired,
            isAppend: formValue.isAppend,
            sectionId: formValue.section.id,
            pickListValues: [],
            maxLengthAfterDecimal: formValue.maxLengthAfterDecimal,
            expression: "",
            type: "",
            prefix: "",
            startingSequenceNumber: 0,
            endingSequenceNumber: 0,
            displayLength: 0,
            isProjected : formValue.isProjected,
            projectedFields: formValue.projectedFields,
            currencyId: formValue?.currencyId
        }

        switch(fieldInfo.formControlId){
            case FormControlListIds.Barcode:
                fieldInfo.type = formValue.type;
                break;
            case FormControlListIds.AutoNumber:
                fieldInfo.prefix = formValue.prefix;
                fieldInfo.startingSequenceNumber = formValue.startingSequenceNumber;
                fieldInfo.endingSequenceNumber = formValue.endingSequenceNumber;
                break;
            case FormControlListIds.Formula:
                fieldInfo.expression = formValue.expression;
                break;
            case FormControlListIds.EncryptedText:
                fieldInfo.displayLength = formValue.displayLength;
                break;
        }

        const pickListValues = JSON.parse(formValue.pickListValues || '[]');

        pickListValues.map(value => {
            fieldInfo.pickListValues.push(value.name);
        });
        this.appMainService.isShowSpinner('createField');
        this.listService.createCustomField(fieldInfo).subscribe({
            next: (response) => {
                this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Custom Field added successfully...' });
                this.displayAddEditCustomField = false;
                this.fieldId = null;
                this.getCustomFieldTypes();
                if (formValue.objectId != this.selectedModule.id) {
                    this.reloadCustomFields(formValue)
                }
            },
            error: (error) => {
                this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: error.error.Message });
                this.appMainService.isHideSpinner('createField');
            },
            complete: () => {
                this.appMainService.isHideSpinner('createField');
            }
        });

    }

    updateAccountCustomField(formValue: any) {
        const fieldInfo: CustomFieldsEditModels = {
            customAttributeId: formValue?.id,
            formControlId: formValue?.formControlId,
            moduleId: formValue?.objectId,
            sectionId: formValue.section?.id,
            isRequired: formValue.isRequired,
            isAppend: formValue.isAppend,
            pickListValues: [],
            maxLengthAfterDecimal: formValue.maxLengthAfterDecimal,
            expression: "",
            type: "",
            prefix: "",
            startingSequenceNumber: 0,
            endingSequenceNumber: 0,
            displayLength: 0,
            isProjected : formValue.isProjected,
            projectedFields: formValue.projectedFields,
            currencyId: formValue.currencyId,
            description: formValue?.description?.trim()
        }

        this.seletedCustomField?.projectedFields?.map(pField => {
            const exist = fieldInfo.projectedFields.find(p => p?.targetModuleId == pField?.targetModuleId);
            if (exist) {
                exist.targetCustomAttributeId = pField.targetCustomAttributeId;
            }else{
                fieldInfo.projectedFields.push({
                    ...pField,
                    statusId: 3
                })
            }
        })

        switch(formValue.formControlId){
            case FormControlListIds.Barcode:
                fieldInfo.type = formValue.type;
                break;
            case FormControlListIds.AutoNumber:
                fieldInfo.prefix = formValue.prefix;
                fieldInfo.startingSequenceNumber = formValue.startingSequenceNumber;
                fieldInfo.endingSequenceNumber = formValue.endingSequenceNumber;
                break;
            case FormControlListIds.Formula:
                fieldInfo.expression = formValue.expression;
                break;
            case FormControlListIds.EncryptedText:
                fieldInfo.displayLength = formValue.displayLength;
                break;
        }

        const pickListValues = JSON.parse(formValue.pickListValues || '[]');

        pickListValues.map(value => {
            fieldInfo.pickListValues.push(value.name);
        });

        this.appMainService.isShowSpinner('updateField');
        this.listService.updateCustomField(fieldInfo).subscribe({
            next: (response) => {
                this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Custom Field updated successfully...' });
                this.displayAddEditCustomField = false;
                this.fieldId = null;
                this.getCustomFieldTypes();
                if (formValue.objectId != this.selectedModule.id) {
                    this.reloadCustomFields(formValue)
                }
            },
            error: (error) => {
                this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: error.error.Message });
                this.appMainService.isHideSpinner('createField');
            },
            complete: () => {
                this.appMainService.isHideSpinner('updateField');
            }
        });
    }

    reloadCustomFields(value) {
        this.selectedModule = this.allModules.find(obj => obj.id == value.objectId);
        this.changeModule();
    }

    changeModuleDropdown(event): void {
        this.moduleId = event.value.id;
        this.customFieldForm.controls['typeId'].setValue(null);
        this.customFieldForm.controls['section'].setValue(null);
        this.customFieldForm.controls['formControlId'].setValue(null);

        this.setAvailableFieldTypes();
        this.updateRequiredFields();
        this.getConfigurationTypes(event);
    }

    setAvailableFieldTypes() {

        this.showAllCustomFieldTypes = this.allCustomFieldTypes.filter(el => el.isShow == true);

        switch (this.moduleId) {
            case CaseModuleId:
            case OpportunityModuleId:
                this.showAllCustomFieldTypes = this.allCustomFieldTypes.filter(el => !this.newFields.includes(el.id));
                break;
        }

        this.showAllCustomFieldTypes.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    }

    updateRequiredFields() {
        if (this.moduleId === AccountModuleId || this.moduleId === OpportunityModuleId || this.moduleId === CaseModuleId) {
            this.customFieldForm.controls['typeId'].clearValidators();
            this.customFieldForm.get('typeId').updateValueAndValidity();
        } else {
            this.customFieldForm.controls['typeId'].setValidators(Validators.required);
        }
    }

    applyValidations(fieldId: number = 0){
        const formControlId = fieldId||this.customFieldForm.value.formControlId?.id||0;

        const validations = {
            type: [],
            prefix: [],
            startingSequenceNumber: [],
            endingSequenceNumber: [],
            expression: [],
            displayLength: [],
            currencyId: []
        }

        switch(formControlId){
            case FormControlListIds.AutoNumber:
                validations.prefix = [Validators.required, Validators.maxLength(3), alphaNumericValidator];
                validations.startingSequenceNumber = [Validators.required];
                validations.endingSequenceNumber = [Validators.required];
                break;
            case FormControlListIds.Barcode:
                validations.type = [Validators.required];
                break;
            case FormControlListIds.EncryptedText:
                validations.displayLength = [Validators.required,Validators.min(0), Validators.max(10)];
                break;
            case FormControlListIds.Currency:
                validations.currencyId = [Validators.required];   
                break;
            case FormControlListIds.Formula:
                validations.expression = [Validators.required];
                break;
        }

        Object.keys(validations).map(key=>{
            this.customFieldForm.controls[key].setValidators(validations[key]);
            this.customFieldForm.controls[key].updateValueAndValidity();
        })
    }

    getAccountTemplates(): void {
        this.sharedTemplateService.getModuleTemplates(this.moduleId).subscribe({
            next: (templates) => {
                this.allTemplates = templates;
            }
        });
    }

    getAccountTemplateSections(selectedSectionId: number = 0): void {
        this.sharedTemplateService.getSections(this.moduleId).subscribe({
            next: (sections) => {
                this.sections = sections.filter(section => ![Sections.CONTACT_DETAILS, Sections.ADDRESS_DETAILS].includes(section.name));
                if (selectedSectionId > 0) {
                    const filteredSection = this.sections.find(section => section.id == selectedSectionId) || this.sections[0];
                    this.customFieldForm.controls['section'].setValue(filteredSection);
                }
            }
        });
    }
    get projectedFields(): FormArray {
        return this.customFieldForm.get('projectedFields') as FormArray;
    }

    onProjectedCheckboxChange(event: any) {
        this.isProjectedEnabled = event.checked;
        if (this.isProjectedEnabled) {
            this.addProjectedField(); // Add a default projected field
        } else {
            this.clearProjectedFields();
        }
    }

    addProjectedField() {
        const projectedField = this.fb.group({
            targetModuleId: [null],
            targetSectionId: [null],
            targetCustomAttributeId: [0],
            statusId: [1]

        });
        this.projectedFields.push(projectedField);
    }

    removeProjectedField(index: number) {
        this.projectedFields.removeAt(index);
    }

    clearProjectedFields() {
        this.projectedFields.clear();
        this.isProjectedEnabled = false;
        this.customFieldForm.controls['isProjected'].setValue(false);
    }

    getConfigurationTypesTargetModules(event, index) {
        this.targetModuleId[index] = event ? event.value : this.selectedModule.id;
        if (this.targetModuleId[index] === AccountModuleId || this.targetModuleId[index] === OpportunityModuleId || this.targetModuleId[index] === CaseModuleId) {
            this.getTargetTemplateSections(index)
        }
    }

    changeTargetModuleDropDown(event, index){
        this.targetModuleId[index] = event.value;
        this.getConfigurationTypesTargetModules(event, index);
    }

    getTargetTemplateSections(index): void {
        this.sharedTemplateService.getSections(this.targetModuleId[index]).subscribe({
            next: (sections) => {
                const targetModulesSection = sections.filter(section => ![Sections.CONTACT_DETAILS, Sections.ADDRESS_DETAILS].includes(section.name));
                this.targetModulesSection[index] = targetModulesSection;
            }
        });
    }

    //#region add/edit expression
    openExpressionAdd(){
        this.expressionText = this.customFieldForm.value.expression||"";
        this.displayAddExpression = true;
    }

    saveExpression(expressionData: {expressionText: string, addedFieldTags: string[]}){
        this.customFieldForm.patchValue({
            expression: expressionData.expressionText
        });
    }

    removeExpression(){
        this.customFieldForm.patchValue({
            expression: null
        });
    }

    expressionDialogClose(){
        this.displayAddExpression = false;
    }
    //#endregion

    //#region autonumber

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    characterOnly(event): boolean {
        const character = (event.which) ? event.which : event.keyCode;
        if (character === 32) {
            return false; // Prevent space character
        }
        if (
            (character >= 65 && character <= 90) || // Uppercase letters
            (character >= 97 && character <= 122) || // Lowercase letters
            (character >= 33 && character <= 47) || // Special characters
            (character >= 58 && character <= 64) || // Special characters
            (character >= 91 && character <= 96) || // Special characters
            (character >= 123 && character <= 126) // Special characters
        ) {
            return true;
        }
        return false;
    }

    //#endregion
 
    loadCurrencies(): void {
        this.importService.getOrgCurrency().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value => {
            if (value) {
                this.currencies = value;
                const activeCurrencies = this.currencies.filter(currency => currency?.statusId === 1);
                this.currencies = activeCurrencies.map((currency) => {
                    return {
                        id: currency.currencyId,
                        name: `${currency.name} - ${currency.code}`
                    };

                });
            }
        })
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
    
}
